import React from 'react';
import { useTranslation } from 'react-i18next';
import UserStatusBadge from '../common/UserStatusBadge';
import ListRecordIdBadge from '../common/ListRecordIdBadge';
import SortableTableHeader from '../common/SortableTableHeader';

const LevelTable = ({ data, onEdit, onArchive, role, sortKey, sortDir, onSort }) => {
    const { t } = useTranslation();
    const canEdit = role === 'ADMIN' || role === 'MANAGER';
    const canArchive = role === 'ADMIN';

    return (
        <div className="overflow-x-auto">
            <table className="min-w-full">
                <thead className="table-header">
                    <tr>
                        {onSort ? (
                            <>
                                <SortableTableHeader label={t('common.idColumn')} columnKey="id" sortKey={sortKey} sortDir={sortDir} onSort={onSort} />
                                <SortableTableHeader label={t('pages.levels.colLevelName')} columnKey="name" sortKey={sortKey} sortDir={sortDir} onSort={onSort} />
                                <SortableTableHeader label={t('batches.branch')} columnKey="branch" sortKey={sortKey} sortDir={sortDir} onSort={onSort} />
                                <SortableTableHeader label={t('common.status')} columnKey="status" sortKey={sortKey} sortDir={sortDir} onSort={onSort} />
                            </>
                        ) : (
                            <>
                                <th className="table-header-cell">{t('common.idColumn')}</th>
                                <th className="table-header-cell">{t('pages.levels.colLevelName')}</th>
                                <th className="table-header-cell">{t('batches.branch')}</th>
                                <th className="table-header-cell">{t('common.status')}</th>
                            </>
                        )}
                        {canEdit && <th className="table-header-cell">{t('common.actions')}</th>}
                    </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                    {data.map((row) => (
                        <tr key={row.levelId ?? row.id} className="table-row">
                            <td className="table-cell whitespace-nowrap">
                                <ListRecordIdBadge id={row.levelId ?? row.id} />
                            </td>
                            <td className="table-cell">
                                <div className="text-sm font-medium text-gray-900">
                                    {row.name || t('pages.levels.levelFallback', { id: row.levelId ?? row.id })}
                                </div>
                            </td>
                            <td className="table-cell">
                                {row.branchName ? (
                                    <>
                                        <div className="text-sm text-gray-900">{row.branchName}</div>
                                        <div className="text-xs text-gray-500">{t('common.idColumn')}: {row.branchId}</div>
                                    </>
                                ) : (
                                    <span className="text-gray-400">{row.branchId ?? '—'}</span>
                                )}
                            </td>
                            <td className="table-cell">
                                <UserStatusBadge active={row.active} />
                            </td>
                            {canEdit && (
                                <td className="table-cell whitespace-nowrap">
                                    <div className="flex items-center gap-2">
                                        <button
                                            type="button"
                                            onClick={() => onEdit(row)}
                                            className="btn-action-edit"
                                            title={t('pages.levels.editLevel')}
                                        >
                                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                            </svg>
                                            {t('common.edit')}
                                        </button>
                                        {canArchive && (
                                            <button
                                                type="button"
                                                onClick={() => onArchive(row)}
                                                className="btn-action-archive"
                                                title={t('pages.levels.archiveLevel')}
                                            >
                                                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
                                                </svg>
                                                {t('common.archive')}
                                            </button>
                                        )}
                                    </div>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default LevelTable;
